(function () {
    "use strict";

    // ResourcePropertyValueIndex will index values returned from the /Solovis/Metadata/ResourcePropertyValues data source.
    // This will only work with one value for a property at a given point in time, so you cannot use this if you are retrieving
    // the all values over time.

    var ResourcePropertyValueIndex = Solovis.defineClass(
        "Solovis.Reports.DataSetHelpers.ResourcePropertyValueIndex",
        null,
        function (options) {
            this._resourceIdToPropValueMap = {};
        });

    
    ResourcePropertyValueIndex.prototype.mergeValues = function (propertyValues) {
        /// <summary>
        /// Merge in property values from /Solovis/Metadata/ResourcePropertyValues. Either entire dataSet or dataSet.propertyValues may be passed in.
        /// </summary>

        var self = this;

        var propValuesList = null;

        if (propertyValues) {            
            if (propertyValues.propertyValues) {
                propValuesList = propertyValues.propertyValues;
            }
            else if (propertyValues.length) {
                propValuesList = propertyValues;
            }
        }

        if (propValuesList) {
            $(propValuesList).each(function (i, propValue: any) {
                var propIdToValueMap;
                if (self._resourceIdToPropValueMap[propValue.resourceId]) {
                    propIdToValueMap = self._resourceIdToPropValueMap[propValue.resourceId];
                }
                else {
                    propIdToValueMap = {};
                    self._resourceIdToPropValueMap[propValue.resourceId] = propIdToValueMap;
                }

                propIdToValueMap[propValue.propertyDefinitionId] = propValue;
            });
        }
    };


    var getPropDefId = function (propDefOrPropDefId) {
        // getPropDefId is a helper function that will return the property id when propDefOrId may be the property definition or the id.
        if (typeof propDefOrPropDefId == "number") {
            return propDefOrPropDefId;
        }
        else if (typeof propDefOrPropDefId == "object" && propDefOrPropDefId.id) {
            return propDefOrPropDefId.id;
        }

        return null;
    };

    ResourcePropertyValueIndex.prototype.getPropValue = function (resourceId, propDefOrPropDefId) {
        /// <summary>
        /// getValue will return the propValue holder; or null, if none is found.
        /// </summary>

        var propDefId = getPropDefId(propDefOrPropDefId);

        if (this._resourceIdToPropValueMap[resourceId]) {
            var propValueMap = this._resourceIdToPropValueMap[resourceId];
            if (propValueMap[propDefId]) {
                var propValue = propValueMap[propDefId];
                return propValue;
            }
        }

        return null;
    };

    ResourcePropertyValueIndex.prototype.getValue = function (resourceId, propDefOrPropDefId) {
        /// <summary>
        /// getValue will return the value property of the propValue holder; or null, if none is found.
        /// </summary>

        var propValue = this.getPropValue(resourceId, propDefOrPropDefId);
        if (propValue && propValue.value) {
            return propValue.value;
        }

        return null;
    };


    ResourcePropertyValueIndex.prototype.getSingleIntegerValue = function (resourceId, propDefOrPropDefId) {
        /// <summary>
        /// getSingleDecimalValue will return the first decimal value; or null, if none is found.
        /// </summary>

        var value = this.getValue(resourceId, propDefOrPropDefId);
        if (value && value.i && value.i.length > 0) {
            return value.i[0];
        }

        return null;
    };

    ResourcePropertyValueIndex.prototype.getSingleDecimalValue = function (resourceId, propDefOrPropDefId) {
        /// <summary>
        /// getSingleDecimalValue will return the first decimal value; or null, if none is found.
        /// </summary>

        var value = this.getValue(resourceId, propDefOrPropDefId);
        if (value && value.d && value.d.length > 0) {
            return value.d[0];
        }

        return null;
    };

    ResourcePropertyValueIndex.prototype.getSingleDayIdValue = function (resourceId, propDefOrPropDefId) {
        /// <summary>
        /// getSingleDecimalValue will return the first dayId value; or null, if none is found.
        /// </summary>

        var value = this.getValue(resourceId, propDefOrPropDefId);
        if (value && value.dt && value.dt.length > 0) {
            return value.dt[0];
        }

        return null;
    };

    ResourcePropertyValueIndex.prototype.getSingleTagIdValue = function (resourceId, propDefOrPropDefId) {
        /// <summary>
        /// getSingleDecimalValue will return the first tag id value for a tag reference; or null, if none is found.
        /// </summary>

        var value = this.getValue(resourceId, propDefOrPropDefId);
        if (value && value.t && value.t.length > 0) {
            return value.t[0];
        }

        return null;
    };

})();